import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class SpendLimitService {

  public customer: CustomerModel;

  constructor(
    private userSession: UserSessionService,
    private webservice: WebservicesService
  ) { 
    userSession.getCustomer().subscribe(
      (customer) => {
          this.customer = customer;
      }
    );
  }

  getGlobalLimits() {
    let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken
    }
    
    return this.webservice.get('responsibleGaming/get-global-limits', obj);
}

getSpendLimit() {
  let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken
  }
  
  return this.webservice.get('responsibleGaming/get-wager-limit', obj);
}

deleteSpendLimit(data: any) {
  let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
      termType: data.termType
  }
  
  return this.webservice.post('responsibleGaming/delete-wager-limit', obj);
}

setSpendLimit(data: any) {
  let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
  }
  
  if (data.spend_daily_limit != null && data.spend_daily_limit != "") {
      obj.daily = data.spend_daily_limit;
  }

  if (data.spend_weekly_limit != null && data.spend_weekly_limit != "") {
      obj.weekly = data.spend_weekly_limit;
  }

  if (data.spend_monthly_limit != null && data.spend_monthly_limit != "") {
      obj.monthly = data.spend_monthly_limit;
  }
  
  return this.webservice.post('responsibleGaming/set-wager-limit', obj);
}


}
